/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails {
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails
     */
    childrenType10?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails
     */
    childrenType15?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails
     */
    childrenType20?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails
     */
    childrenType30?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails
     */
    childrenType40?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails
     */
    childrenType50?: number;
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails {
    return JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'childrenType10': !exists(json, 'childrenType10') ? undefined : json['childrenType10'],
        'childrenType15': !exists(json, 'childrenType15') ? undefined : json['childrenType15'],
        'childrenType20': !exists(json, 'childrenType20') ? undefined : json['childrenType20'],
        'childrenType30': !exists(json, 'childrenType30') ? undefined : json['childrenType30'],
        'childrenType40': !exists(json, 'childrenType40') ? undefined : json['childrenType40'],
        'childrenType50': !exists(json, 'childrenType50') ? undefined : json['childrenType50'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetailsToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseSubsidyGetResponseMemberChldDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'childrenType10': value.childrenType10,
        'childrenType15': value.childrenType15,
        'childrenType20': value.childrenType20,
        'childrenType30': value.childrenType30,
        'childrenType40': value.childrenType40,
        'childrenType50': value.childrenType50,
    };
}

